var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuthenticateRLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 155,
    viewBox: "0 0 150 155",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6657_125972)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9077 98.8979L0.5 155H33.7299L45.4928 121.035L20.9077 98.8979Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1075 90.2069L70.6475 40.5981C75.2447 54.3839 79.842 68.1796 84.4392 81.9654L109.774 63.6043L86.6478 0H57.1157L26.9839 83.3939L54.1075 90.2069Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.9824 115.231L110.024 155H143.254L118.729 87.5796L95.9824 115.231Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7314 85.9613L69.2185 99.6871L149.51 41.5671L71.3073 136.839L14.7314 85.9613Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.425 89.4151C125.425 86.8485 127.243 84.9124 129.914 84.9124C132.586 84.9124 134.419 86.8337 134.419 89.4151C134.419 91.9966 132.586 93.9031 129.914 93.9031C127.243 93.9031 125.425 92.004 125.425 89.4151ZM129.914 92.8571C131.903 92.8571 133.306 91.4032 133.306 89.4151C133.306 87.4271 131.903 85.9509 129.914 85.9509C127.926 85.9509 126.538 87.4271 126.538 89.4151C126.538 91.4032 127.926 92.8571 129.914 92.8571ZM127.992 86.9449H130.271C131.28 86.9449 131.8 87.5606 131.8 88.3321C131.8 88.9181 131.54 89.3113 130.976 89.4819C132.059 89.7563 131.592 91.2326 131.955 91.826H130.753C130.293 90.9507 130.909 89.9566 129.773 89.9566H129.21V91.826H127.992V86.9449ZM129.21 87.9389V89.0516H129.877C130.308 89.0516 130.545 88.8662 130.545 88.5027C130.545 88.1392 130.338 87.9389 129.877 87.9389H129.21Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6657_125972"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 149,
    height: 155,
    fill: "currentColor",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthenticateRLogoWhite);
export default __webpack_public_path__ + "static/media/Authenticate_R_logo_white.a643df5f45e59c4ac828c75d2b264ce2.svg";
export { ForwardRef as ReactComponent };